export const BE_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:9999';